export default function list({ variables }) {
    return {
        MuiList: {
            styleOverrides: {
                root: {
                    paddingTop: variables.spacing_02,
                    paddingBottom: variables.spacing_02,
                },
            },
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    borderRadius: variables.border_radius_small,
                    paddingTop: variables.spacing_02,
                    paddingBottom: variables.spacing_02,
                    "&:hover": {
                        backgroundColor: variables.surface_hover,
                    },
                    "&.Mui-selected": {
                        backgroundColor: variables.surface_selected,
                        "&:hover": {
                            backgroundColor: variables.surface_selected_hover,
                        },
                    },
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: "32px",
                    color: variables.text_medium,
                },
            },
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    fontSize: variables.type_body_font_size,
                },
                secondary: {
                    fontSize: variables.type_caption_font_size,
                    color: variables.text_medium,
                },
            },
        },
        MuiListSubheader: {
            styleOverrides: {
                root: {
                    fontSize: variables.type_overline_font_size,
                    fontWeight: variables.type_overline_font_weight,
                    letterSpacing: variables.overline_letter_spacing_wide,
                    textTransform: "uppercase",
                    color: variables.text_medium,
                    lineHeight: 2.4,
                    backgroundColor: "transparent",
                },
            },
        },
    };
}
//# sourceMappingURL=list.js.map